import { BaseService } from '../BaseService'
import { httpClient } from '../HttpClient'
import { ILibraryService } from '../ILibraryService'
import { AxiosRequestConfig } from 'axios'
import SubscriptionLibraryUpsertRequest from '../request_objects/libraries/SubscriptionLibraryUpsertRequest'

export class LibraryService implements BaseService, ILibraryService {
  public END_POINT: string = 'cms'
  public VERSION: string = process.env.VUE_APP_VERSION_CMS
  public PUBLIC_LIBRARIES: string = `${this.END_POINT}/${this.VERSION}/public-libraries`
  public LIBRARIES: string = `${this.END_POINT}/${this.VERSION}/libraries`
  public SUBSCRIPTION_LIBRARIES: string = `${this.END_POINT}/${this.VERSION}/subscription-libraries`

  public async getAll(config?: AxiosRequestConfig): Promise<any> {
    return await httpClient.get(`${this.LIBRARIES}`, config)
  }

  public async getSubscriptionLibraries(config?: AxiosRequestConfig): Promise<any> {
    return await httpClient.get(`${this.SUBSCRIPTION_LIBRARIES}/search`, config)
  }

  public async getCost(config?: AxiosRequestConfig, data?: any): Promise<object> {
    return await httpClient.post(`${this.SUBSCRIPTION_LIBRARIES}/price-by-ids`, data, config)
  }

  public async updatePublicPurchaseStatus(config?: AxiosRequestConfig): Promise<object> {
    return await httpClient.patch(`${this.SUBSCRIPTION_LIBRARIES}/update-premium-libraries`, config.params)
  }

  public async updateLibrarySubscriptions(request?: SubscriptionLibraryUpsertRequest): Promise<any> {
    return await httpClient.put(`${this.SUBSCRIPTION_LIBRARIES}/upsert-library-subscription`, request)
  }
}
